<template>
  <body class="trust-body">
    <img
      class="trust-image"
      src="../../../assets/WecobiTrust.png"
      alt="wecobi-trust"
    />
    <div class="trust-wrapper">
      <div class="trust-text">
        Learn why the world’s leading brands trust <span>Wecobi</span>
      </div>
      <router-link to="/learnWhy" class="trust-button"> Explore</router-link>
    </div>
  </body>
</template>

<script>
export default {
  name: "TrustWecobi",
};
</script>
<style scoped>
.trust-body {
  width: 100%;
  height: 620px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
}
.trust-image {
  max-width: 722px;
  position: absolute;
  bottom: -82px;
  left: 50;
}
.trust-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  z-index: 5;
}
.trust-text {
  font-size: 40px;
  font-weight: 600;
  color: #ffffff;
  max-width: 720px;
  text-align: center;
}
span {
  color: #ff6d0a;
}

.trust-button {
  width: 120px;
  height: 50px;
  font-size: 17px;
  font-weight: 600;
  color: #ffffff;
  border: 2px solid #ffffff;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.trust-button:hover {
  color: #000000;
  border: 2px solid #ffffff;
  background-color: #ffffff;
}
@media (max-width: 1024px) {
  .trust-body {
    height: 430px;
  }
  .trust-text {
    font-size: 35px;
    max-width: 609px;
  }
  .trust-image {
    max-width: 645px;
  }
}
@media (max-width: 744px) {
  .trust-body {
    height: 434px;
  }
  .trust-text {
    max-width: 437px;
  }
  .trust-image {
    max-width: 100%;
  }
}
@media (max-width: 588px) {
  .trust-button {
    width: 98px;
    height: 40px;
    font-size: 14px;
  }
}
@media (max-width: 430px) {
  .trust-body {
    height: 388px;
  }
  .trust-text {
    font-size: 25px;
    max-width: 343px;
  }
}
</style>
